export default "__VITE_ASSET__4c299e26__"